import React, { useEffect, useState } from "react";
import { PageHeader, Modal, Toast, PasswordInput } from "@/components/Layout";
import api, { API } from "@/lib/api";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import MfaCard from "@/components/MfaCard";

export default function MyAccount() {
  const { has, hasModule } = useAuth();
  // unde își poate vedea persoana contractele: dosarul ei electronic (documentele contractului) sau, pentru cine are dreptul, Rapoarte de Muncă
  const dossierLink = hasModule("employee_files") && has("documents.my_files") ? { to: "/employee-files", label: "Deschide dosarul electronic" } : null;
  const employmentsLink = has("employments.view") && (has("employments.create") || has("employments.update")) ? { to: "/mdm/employments", label: "Deschide Rapoarte de Muncă" } : null;
  const [profile, setProfile] = useState(null);
  const [pwd, setPwd] = useState({ old:"", new:"", conf:"" });
  const [showPwd, setShowPwd] = useState(false);
  const [msg, setMsg] = useState({text:"",type:"info"});

  const load = () => api.get("/my/profile").then(r => setProfile(r.data));
  const [accessProfiles, setAccessProfiles] = useState([]);
  useEffect(() => { load(); api.get("/auth/permissions").then(r => setAccessProfiles(r.data.profiles || [])).catch(() => {}); }, []);

  const uploadSig = async (file) => {
    if (!file) return;
    try {
      const fd = new FormData(); fd.append("file", file);
      await api.post("/my/signature", fd, { headers: {"Content-Type":"multipart/form-data"} });
      setMsg({text:"Semnătură încărcată. Va fi aplicată în raportul Programare CO.",type:"success"});
      setTimeout(()=>setMsg({text:""}),2500); load();
    } catch(e) { setMsg({text:e?.response?.data?.detail||"Eroare upload",type:"error"}); }
  };
  const delSig = async () => { if(!window.confirm("Ștergi semnătura?")) return;
    await api.delete("/my/signature"); load(); };

  const changePwd = async () => {
    if (pwd.new !== pwd.conf) { setMsg({text:"Confirmarea nu coincide",type:"error"}); return; }
    try {
      await api.post("/my/change-password", { old_password: pwd.old, new_password: pwd.new });
      setShowPwd(false); setPwd({old:"",new:"",conf:""});
      setMsg({text:"Parolă schimbată",type:"success"}); setTimeout(()=>setMsg({text:""}),2000);
    } catch(e) { setMsg({text:e?.response?.data?.detail||"Eroare",type:"error"}); }
  };

  if (!profile) return <div>Se încarcă...</div>;
  const u = profile.user;
  const sigUrl = u.signature_url ? `${process.env.REACT_APP_BACKEND_URL}${u.signature_url}` : null;

  return (
    <>
      <PageHeader title="Contul meu" subtitle="Date personale, semnătură, securitate" />
      <Toast msg={msg.text} type={msg.type} />

      <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:16}}>
        <div className="card" style={{padding:22}}>
          <h3 style={{margin:"0 0 14px",fontSize:15,fontWeight:700}}>Date personale (view-only)</h3>
          <div style={{display:"grid",gap:10,fontSize:13}}>
            {[["Utilizator","username"],["Nume","last_name"],["Prenume","first_name"],["CNP","cnp"],["Email","email"],["Telefon","phone"]].map(([l,k])=>(
              <div key={k} style={{display:"grid",gridTemplateColumns:"140px 1fr",gap:8}}>
                <span style={{color:"#64748B",fontWeight:600,fontSize:12,textTransform:"uppercase"}}>{l}</span>
                <span style={{color:"var(--navy)",fontWeight:500}}>{u[k] || "—"}</span>
              </div>
            ))}
            <div style={{display:"grid",gridTemplateColumns:"140px 1fr",gap:8,marginTop:8,paddingTop:8,borderTop:"1px solid #F1F5F9"}}>
              <span style={{color:"#64748B",fontWeight:600,fontSize:12,textTransform:"uppercase"}}>Roluri</span>
              <span>{(profile.roles||[]).map(r=>r.role).join(", ") || "—"}</span>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"140px 1fr",gap:8}} data-testid="my-profiles">
              <span style={{color:"#64748B",fontWeight:600,fontSize:12,textTransform:"uppercase"}}>Profiluri de acces</span>
              <span>{accessProfiles.length ? accessProfiles.map((s, i) => (
                <span key={i} style={{display:"inline-block",marginRight:6,fontSize:12,padding:"2px 8px",borderRadius:99,background:"#F5F3FF",color:"#5B21B6",border:"1px solid #DDD6FE"}}>
                  {s.name} · {s.scope || "Toată platforma"}{s.personnel_categories.length ? ` · ${s.personnel_categories.join(", ")}` : ""}{s.valid_to ? ` · până la ${s.valid_to}` : ""}
                </span>)) : "—"}</span>
            </div>
          </div>
        </div>

        <div className="card" style={{padding:22}}>
          <h3 style={{margin:"0 0 14px",fontSize:15,fontWeight:700}}>Semnătură olografă</h3>
          <div style={{fontSize:12,color:"#64748B",marginBottom:12}}>Va fi aplicată automat pe raportul „Programare CO" în coloana „Semnătura salariatului".</div>
          {sigUrl ? (
            <div style={{background:"#F8FAFC",border:"1px solid #E2E8F0",borderRadius:8,padding:16,textAlign:"center"}}>
              <img src={sigUrl} alt="semnătură" style={{maxWidth:280,maxHeight:120,objectFit:"contain"}} data-testid="signature-preview" />
              <div style={{marginTop:10,display:"flex",gap:8,justifyContent:"center"}}>
                <label className="btn btn-secondary" style={{cursor:"pointer"}}>
                  Înlocuiește
                  <input type="file" accept="image/png,image/jpeg" style={{display:"none"}} onChange={e=>uploadSig(e.target.files?.[0])} data-testid="sig-file-replace" />
                </label>
                <button className="btn btn-danger" onClick={delSig} data-testid="sig-delete">Șterge</button>
              </div>
            </div>
          ) : (
            <div style={{border:"2px dashed #93C5FD",borderRadius:8,padding:20,textAlign:"center"}}>
              <div style={{marginBottom:10,fontSize:13,color:"#334155"}}>Încarcă o imagine cu semnătura (PNG sau JPG)</div>
              <input type="file" accept="image/png,image/jpeg" onChange={e=>uploadSig(e.target.files?.[0])} data-testid="sig-file" />
            </div>
          )}
        </div>
      </div>

      <div className="card" style={{padding:22,marginTop:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <h3 style={{margin:0,fontSize:15,fontWeight:700}}>Securitate</h3>
          <button className="btn btn-primary" onClick={()=>setShowPwd(true)} data-testid="change-pw">Schimbă parola</button>
        </div>
        <div style={{fontSize:12,color:"#64748B",marginTop:8}}>
          {u.must_change_password ? "⚠️ Trebuie să îți schimbi parola curentă." : "Parola ta este activă."}
        </div>
      </div>

      <MfaCard />

      {(profile.contracts || []).length > 0 && (
        <div className="card" style={{padding:22,marginTop:16}} data-testid="my-contracts">
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
            <div>
              <h3 style={{margin:"0 0 4px",fontSize:15,fontWeight:700}}>Contractele mele de muncă ({profile.contracts.length})</h3>
              <div style={{fontSize:12,color:"#64748B",marginBottom:14}}>Rapoartele de muncă legate de contul tău, cu datele contractului. Documentele contractului se văd în dosarul tău electronic.</div>
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {dossierLink && <Link className="btn btn-secondary" to={dossierLink.to} data-testid="my-contracts-dossier">{dossierLink.label} →</Link>}
              {employmentsLink && <Link className="btn btn-secondary" to={employmentsLink.to} data-testid="my-contracts-employments">{employmentsLink.label} →</Link>}
            </div>
          </div>
          <div style={{overflowX:"auto"}}>
          <table className="tbl">
            <thead><tr><th>Marcă</th><th>Structură</th><th>Funcție</th><th>Contract</th><th>Normă</th><th>Perioadă</th><th>Status</th></tr></thead>
            <tbody>{profile.contracts.map(c => {
              const st = { active: ["Activ","badge-active"], suspended: ["Suspendat",""], terminated: ["Încetat","badge-inactive"] }[c.status] || [c.status, ""];
              return (
                <tr key={c.id} data-testid={`contract-${c.marca}`}>
                  <td style={{fontWeight:600}} className="tabular-nums">{c.marca}</td>
                  <td>{c.org_unit_name || "—"}</td>
                  <td>{c.position_title || "—"}</td>
                  <td>{[c.contract_type_label, c.contract_number && `nr. ${c.contract_number}`, c.registration_date && `din ${c.registration_date}`].filter(Boolean).join(" ") || "—"}{c.duration_label === "Determinată" ? " · determinată" : ""}</td>
                  <td>{c.norm_label || "—"}</td>
                  <td className="tabular-nums" style={{whiteSpace:"nowrap"}}>{c.start_date || "—"} → {c.end_date || "prezent"}</td>
                  <td><span className={"badge " + st[1]}>{st[0]}</span></td>
                </tr>);
            })}</tbody>
          </table>
          </div>
        </div>
      )}

      {profile.employments.length > 0 && (
        <div className="card" style={{padding:22,marginTop:16}}>
          <h3 style={{margin:"0 0 4px",fontSize:15,fontWeight:700}}>Soldurile mele de concediu</h3>
          <div style={{fontSize:12,color:"#64748B",marginBottom:14}}>Valorile din „CO disponibile" pentru fiecare raport de muncă al tău — nu raportul oficial (PDF/Excel), doar cifrele.</div>
          <div style={{overflowX:"auto"}}>
          <table className="tbl">
            <thead><tr>
              <th>Marcă</th><th>Structură</th><th>Funcție</th><th>Punct de lucru</th><th>Categorie</th>
              <th className="tabular-nums">CO an programare</th>
              <th className="tabular-nums">CO reportat</th>
              <th className="tabular-nums">Din care expiră 30.06</th>
              <th className="tabular-nums">CO condiții vătămătoare</th>
              <th className="tabular-nums">CO alte situații</th>
              <th className="tabular-nums">Total CO</th>
            </tr></thead>
            <tbody>{profile.employments.map(e=>(
              <tr key={e.id} data-testid={`empl-${e.marca}`}>
                <td style={{fontWeight:600}} className="tabular-nums">{e.marca}</td>
                <td>{e.org_unit_name}</td>
                <td>{e.position_title || "—"}</td>
                <td>{e.location_name || "—"}</td>
                <td>{e.personnel_category}</td>
                <td className="tabular-nums">{e.co_year_available||0}</td>
                <td className="tabular-nums">{e.co_carried_previous||0}</td>
                <td className="tabular-nums">{e.co_expires_june30||0}</td>
                <td className="tabular-nums">{e.co_extra_hazardous||0}</td>
                <td className="tabular-nums">{e.co_extra_other||0}</td>
                <td className="tabular-nums" style={{fontWeight:700}}>{e.total_co_available}z</td>
              </tr>
            ))}</tbody>
          </table>
          </div>
        </div>
      )}

      {showPwd && (
        <Modal title="Schimbă parola" onClose={()=>setShowPwd(false)}>
          <div style={{display:"grid",gap:12}}>
            <div><label className="label label-req">Parola curentă</label>
              <PasswordInput autoComplete="current-password" value={pwd.old} onChange={e=>setPwd({...pwd,old:e.target.value})} testId="pw-old" /></div>
            <div><label className="label label-req">Parolă nouă (minim 12 caractere)</label>
              <PasswordInput autoComplete="new-password" value={pwd.new} onChange={e=>setPwd({...pwd,new:e.target.value})} testId="pw-new" /></div>
            <div><label className="label label-req">Confirmă parolă nouă</label>
              <PasswordInput autoComplete="new-password" value={pwd.conf} onChange={e=>setPwd({...pwd,conf:e.target.value})} testId="pw-conf" /></div>
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
            <button className="btn btn-secondary" onClick={()=>setShowPwd(false)}>Anulează</button>
            <button className="btn btn-primary" onClick={changePwd} data-testid="pw-save">Salvează</button>
          </div>
        </Modal>
      )}
    </>
  );
}
